/**
 * Builds a hierarchical structure of collections from a flat array.
 *
 * Each collection object will have a `children` property that contains its sub-collections.
 *
 * The root collections will be at the top level of the returned array.
 *
 * @param {Array} collections - The flat array of collections.
 * @returns {Array} - The hierarchical structure of collections.
 */
const buildCategoryHierarchy = (collections) => {
    const map = {};
    const roots = [];

    collections.forEach((item) => {
        map[item.id] = {
            ...item,
            children: []
        };
    });

    collections.forEach((item) => {
        if (item.parentId === null) {
            roots.push(map[item.id]);
        } else if (map[item.parentId]) {
            map[item.parentId].children.push(map[item.id]);
        }
    });

    return roots;
};

export default buildCategoryHierarchy;